import { render, staticRenderFns } from "./addExam.vue?vue&type=template&id=140c26d3&scoped=true"
import script from "./addExam.vue?vue&type=script&lang=js"
export * from "./addExam.vue?vue&type=script&lang=js"
import style0 from "./addExam.vue?vue&type=style&index=0&id=140c26d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c26d3",
  null
  
)

export default component.exports